import { PapiDeviation } from '@wix/da-papi-types';
import DeviationMediaService, {
  fallbackToLargestFile,
} from '../../../utils/DeviationMediaService';
import ddt from '@wix/da-ddt';
import { isValidFileSrc } from '../../../DeviationViews/_helpers';
import { DaDeviationOptions } from '@wix/da-editor-tiptap/pkg/extensions/extension-deviation/deviation';

export const getImageStylesAndSrc = (
  deviation: PapiDeviation,
  width: number,
  config: DaDeviationOptions,
  containerWidth?: number
) => {
  ddt.log('measuredhook', 'Image - container width', { containerWidth });
  const fullview = DeviationMediaService.getLargestFullview(deviation);
  if (!fullview) {
    ddt.log('Editor', 'Not rendering mono image - no fullview', deviation);
    return false;
  }

  // Calculate the width and height of the block
  const fvImageRatio = (fullview.width || 0) / (fullview.height || 0);
  const coverWidth = width || 780;
  const coverHeight = coverWidth / fvImageRatio;

  const coverThumb = DeviationMediaService.getSmallestThumbThatFullyCovers(
    deviation,
    coverWidth,
    coverHeight,
    fallbackToLargestFile,
    { allowFullview: true, allowPreview: true }
  );

  if (!coverThumb || !isValidFileSrc(coverThumb.src)) {
    ddt.log('Editor', 'Not rendering mono image', deviation);
    return false;
  }

  // Dont stretch things - max is the fullview width
  // we then let browser decide whats best using srcset
  let imgWidth: React.CSSProperties['width'] = '100%';
  if (!width || (fullview.width || 0) < Number(width)) {
    imgWidth = fullview.width;
  }

  const actualWidth = width || containerWidth;
  // Dont over pad small images
  let boundHeight = actualWidth! / fvImageRatio;
  if (fullview.height && boundHeight > fullview.height) {
    boundHeight = fullview.height;
  }
  ddt.log('measuredhook', 'Image size', {
    actualWidth,
    propsWidth: width,
    containerWidth,
    boundHeight,
    fvImageRatio,
    fvHeight: fullview.height,
  });

  const wrapperStyles: React.CSSProperties = {
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    width: actualWidth || '100%',
    height: `${boundHeight}px`,
  };

  const imgStyles: React.CSSProperties = {
    width: imgWidth,
    maxWidth: '100%',
    display: 'block' /* fixes wrappers not being correct height */,
  };
  const allowFullview = (fullview.width || 0) > (Number(width) || 0);
  const canBeLinked = deviation.isPublished;

  return {
    allowFullview,
    imgStyles,
    wrapperStyles,
    coverThumb,
    fullview,
    canBeLinked,
  };
};
